import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './AdminApplication.css';
import privateAxios from '../../utils/axios/privateAxios';
import moment from 'moment';

const AdminApplication = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApplication = async () => {
      try {
        const response = await privateAxios.get(`/private/admin-application/${id}`);
        setApplication(response.data.submission);
      } catch (error) {
        console.error('Error fetching application', error);
      } finally {
        setLoading(false);
      }
    };

    fetchApplication();
  }, [id]);

  if (loading) return <div className="admin-application-loading">Loading...</div>;

  if (!application) return <div className="admin-application-error">Application not found.</div>;

  return (
    <div className="admin-application">
      <div className="admin-application-header">
        <h1>{application.form.title}</h1>
        <p className="admin-application-meta">
          By: {application.applicant?.firstname} {application.applicant?.lastname} {application.applicant?.email} | Created: {moment(application.createdAt).format('MMMM DD, YYYY')}
  
        </p>
      </div>

      <div className="admin-application-content">
        {application.applicationReason}
      </div>

      <div className="admin-application-actions">
        {/* <button onClick={() => navigate(`/admin-edit-application/${id}`)}>Edit Application</button> */}
        <button onClick={() => navigate('/admin-applications')}>Back to Applications</button>
      </div>
    </div>
  );
};

export default AdminApplication;